module.exports = __webpack_public_path__ + "img/124ne.05cd1279.svg";